export enum LifeBenefitType {
    GROUP_TERM_LIFE = 'Group term life',
    GROUP_VOLUNTARY_TERM_LIFE = 'Group voluntary term life',
    GROUP_UNIVERSAL_LIFE = 'Group universal life',
    SUPPLEMENTAL_LIFE = 'Supplemental life'
}